import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-horse-label',
  templateUrl: './horse-label.component.html',
  styleUrls: ['./horse-label.component.scss']
})
export class HorseLabelComponent implements OnInit {


  @Input() horse: any;
  @Input() fontSize: string = '13px';
  @Input() onlyMobileVisibility: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
